// The module cache
var installedModules = {};

// object to store loaded and loading chunks
// "0" means "already loaded"
// Array means "loading", array contains callbacks
var installedChunks = {0:0};

// The require function
function require(moduleId) {
	// Check if module is in cache
	if(installedModules[moduleId])
		return installedModules[moduleId].exports;
	
	// Create a new module (and put it into the cache)
	var module = installedModules[moduleId] = {
		exports: {},
		id: moduleId,
		loaded: false,
		hot: hotCreateModule(moduleId),
		parents: [hotCurrentParent],
		data: hotCurrentModuleData[moduleId],
		children: []
	};
	
	// Execute the module function
	modules[moduleId].call(null, module, module.exports, hotCreateRequire(moduleId));
	
	// Flag the module as loaded
	module.loaded = true;
	
	// Return the exports of the module
	return module.exports;
}

// This file contains only the entry chunk.
// The chunk loading function for additional chunks
require.e = function requireEnsure(chunkId, callback) {
	// "0" is the signal for "already loaded"
	if(installedChunks[chunkId] === 0)
		return callback.call(null, require);
	
	// an array means "currently loading".
	if(installedChunks[chunkId] !== undefined) {
		installedChunks[chunkId].push(callback);
	} else {
		// start chunk loading
		installedChunks[chunkId] = [callback];
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.charset = 'utf-8';
		script.src = modules.c + "" + hotCurrentHash + "/js/" + chunkId + ".js";
		head.appendChild(script);
	}
};

// expose the modules object (__webpack_modules__)
require.modules = modules;

// expose the module cache
require.cache = installedModules;

// install a JSONP callback for chunk loading
window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, callbacks = [];
	while(chunkIds.length) {
		chunkId = chunkIds.shift();
		if(installedChunks[chunkId])
			callbacks.push.apply(callbacks, installedChunks[chunkId]);
		installedChunks[chunkId] = 0;
	}
	for(moduleId in moreModules) {
		modules[moduleId] = moreModules[moduleId];
	}
	while(callbacks.length)
		callbacks.shift().call(null, require);
};
this["webpackHotUpdate"] = function webpackHotUpdateCallback(chunkId, moreModules) {
	for(var moduleId in moreModules) {
		if(moreModules[moduleId])
			hotUpdate[moduleId] = moreModules[moduleId];
		else if(!hotUpdate[moduleId])
			hotUpdate[moduleId] = false;
	}
	if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
		hotUpdateDownloaded();
	}
}

var hotApplyOnUpdate = true;
var hotCurrentHash = "27b0f17f2af00286073d";
var hotCurrentModuleData = {};
var hotCurrentParent = 0;

function hotCreateRequire(moduleId) {
	var me = installedModules[moduleId];
	var fn = function(request) {
		if(installedModules[request] && installedModules[request].parents.indexOf(moduleId) < 0)
			installedModules[request].parents.push(moduleId);
		if(me && me.children.indexOf(request) < 0)
			me.children.push(request);
		hotCurrentParent = moduleId;
		return require(request);
	};
	fn.e = function(chunkId, callback) {
		if(hotStatus === "ready")
			hotSetStatus("prepare");
		hotChunksLoading++;
		require.e(chunkId, function() {
			try {
				callback.call(null, fn);
			} catch(e) {
				finishChunkLoading();
				throw e;
			}
			finishChunkLoading();
			function finishChunkLoading() {
				hotChunksLoading--;
				if(hotStatus === "prepare") {
					if(!hotWaitingFilesMap[chunkId]) {
						hotDownloadUpdateChunk(chunkId);
					}
					if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
						hotUpdateDownloaded();
					}
				}
			}
		});
	}
	fn.cache = require.cache;
	fn.modules = require.modules;
	return fn;
}

function hotCreateModule(moduleId) {
	var hot = {
		// private stuff
		_acceptedDependencies: {},
		_declinedDependencies: {},
		_selfAccepted: false,
		_selfDeclined: false,
		_disposeHandlers: [],

		// Module API
		accept: function(dep, callback) {
			if(typeof dep === "undefined")
				hot._selfAccepted = true;
			else if(typeof dep === "number")
				hot._acceptedDependencies[dep] = callback;
			else for(var i = 0; i < dep.length; i++)
				hot._acceptedDependencies[dep[i]] = callback;
		},
		decline: function(dep) {
			if(typeof dep === "undefined")
				hot._selfDeclined = true;
			else if(typeof dep === "number")
				hot._declinedDependencies[dep] = true;
			else for(var i = 0; i < dep.length; i++)
				hot._declinedDependencies[dep[i]] = true;
		},
		dispose: function(callback) {
			hot._disposeHandlers.push(callback);
		},
		addDisposeHandler: function(callback) {
			hot._disposeHandlers.push(callback);
		},
		removeDisposeHandler: function(callback) {
			var idx = hot._disposeHandlers.indexOf(callback);
			if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
		},

		// Management API
		check: hotCheck,
		apply: hotApply,
		setApplyOnUpdate: function(applyOnUpdate) {
			hotApplyOnUpdate = applyOnUpdate;
		},
		status: function(l) {
			if(!l) return hotStatus;
			hotStatusHandlers.push(l);
		},
		addStatusHandler: function(l) {
			hotStatusHandlers.push(l);
		},
		removeStatusHandler: function(l) {
			var idx = hotStatusHandlers.indexOf(l);
			if(idx >= 0) hotStatusHandlers.splice(idx, 1);
		}
	};
	return hot;
}

var hotStatusHandlers = [];
var hotStatus = "idle";

function hotSetStatus(newStatus) {
	var oldStatus = hotStatus;
	hotStatus = newStatus;
	for(var i = 0; i < hotStatusHandlers.length; i++)
		hotStatusHandlers[i].call(null, newStatus);
}

// while downloading
var hotWaitingFiles = 0;
var hotChunksLoading = 0;
var hotWaitingFilesMap = {};
var hotAvailibleFilesMap = {};
var hotCallback;

// The update info
var hotUpdate, hotUpdateNewHash;

function hotCheck(callback) {
	callback = callback || function(err) { if(err) throw err };
	if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
	if(typeof XMLHttpRequest === "undefined")
		return callback(new Error("No browser support"));
	hotSetStatus("check");

	try {
		var request = new XMLHttpRequest();
		request.open("GET", modules.c + "" + hotCurrentHash + "/update.json", true);
		request.send(null);
	} catch(err) {
		return callback(err);
	}
	request.onreadystatechange = function() {
		if(request.readyState !== 4) return;
		if(request.status !== 200 && request.status !== 304) {

			hotSetStatus("idle");
			callback(null, null);

		} else {

			try {
				var update = JSON.parse(request.responseText);
			} catch(e) {
				hotSetStatus("idle");
				callback(null, null);
				return;
			}

			hotAvailibleFilesMap = {};
			hotWaitingFilesMap = {};
			for(var i = 0; i < update.c.length; i++)
				hotAvailibleFilesMap[update.c[i]] = true;
			hotUpdateNewHash = update.h;

			hotSetStatus("prepare");
			hotCallback = callback;
			hotUpdate = {};
			for(var chunkId in installedChunks) {
				hotDownloadUpdateChunk(chunkId);
			}
			if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
				hotUpdateDownloaded();
			}
		}
	};
}

function hotDownloadUpdateChunk(chunkId) {
	if(hotAvailibleFilesMap[chunkId]) {
		hotWaitingFiles++;
		var head = document.getElementsByTagName('head')[0];
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.charset = 'utf-8';
		script.src = modules.c + "" + hotCurrentHash + "/js/" + chunkId + ".update.js";
		head.appendChild(script);
	}
	hotWaitingFilesMap[chunkId] = true;
}

function hotUpdateDownloaded() {
	hotSetStatus("ready");
	var callback = hotCallback;
	hotCallback = null;
	if(!callback) return;
	if(hotApplyOnUpdate) {
		hotApply(callback);
	} else {
		var outdatedModules = [];
		for(var id in hotUpdate) {
			outdatedModules.push(+id);
		}
		callback(null, outdatedModules);
	}
}

function hotApply(callback) {
	callback = callback || function(err) { if(err) throw err };
	if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
	var outdatedDependencies = {};
	var outdatedModules = [];
	for(var id in hotUpdate) {
		outdatedModules.push(+id);
	}
	var queue = outdatedModules.slice();
	while(queue.length > 0) {
		var moduleId = queue.pop();
		var module = installedModules[moduleId];
		if(!module || module.hot._selfAccepted)
			continue;
		if(module.hot._selfDeclined) {
			hotSetStatus("abort");
			return callback(new Error("Aborted because of self decline: " + moduleId));
		}
		if(moduleId === 0) {
			hotSetStatus("abort");
			return callback(new Error("Aborted because of bubbling"));
		}
		for(var i = 0; i < module.parents.length; i++) {
			var parentId = module.parents[i];
			var parent = installedModules[parentId];
			if(parent.hot._declinedDependencies[moduleId]) {
				hotSetStatus("abort");
				return callback(new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId));
			}
			if(outdatedModules.indexOf(parentId) >= 0) continue;
			if(parent.hot._acceptedDependencies[moduleId]) {
				if(!outdatedDependencies[parentId]) outdatedDependencies[parentId] = [];
				if(outdatedDependencies[parentId].indexOf(moduleId) >= 0) continue;
				outdatedDependencies[parentId].push(moduleId);
				continue;
			}
			delete outdatedDependencies[parentId];
			outdatedModules.push(parentId);
			queue.push(parentId);
		}
	}

	var outdatedSelfAcceptedModules = [];
	for(var i = 0; i < outdatedModules.length; i++) {
		var moduleId = outdatedModules[i];
		if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
			outdatedSelfAcceptedModules.push(moduleId);
	}

	hotSetStatus("dispose");
	hotCurrentModuleData = {};
	for(var i = 0; i < outdatedModules.length; i++) {
		var moduleId = outdatedModules[i];
		var data = {};
		var module = installedModules[moduleId];
		if(!module) continue;
		var disposeHandlers = module.hot._disposeHandlers;
		for(var j = 0; j < disposeHandlers.length; j++) {
			var cb = disposeHandlers[j]
			cb(data);
		}
		hotCurrentModuleData[moduleId] = data;
	}
	for(var i = 0; i < outdatedModules.length; i++) {
		var moduleId = outdatedModules[i];
		var module = installedModules[moduleId];
		if(!module) continue;
		delete installedModules[moduleId];
		for(var j = 0; j < module.children.length; j++) {
			var child = installedModules[module.children[j]];
			if(!child) continue;
			var idx = child.parents.indexOf(moduleId);
			if(idx >= 0) child.parents.splice(idx, 1);
		}
	}
	for(var moduleId in outdatedDependencies) {
		var module = installedModules[moduleId];
		var moduleOutdatedDependencies = outdatedDependencies[moduleId];
		for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
			var dependency = moduleOutdatedDependencies[j];
			var idx = module.children.indexOf(dependency);
			if(idx >= 0) module.children.splice(idx, 1);
		}
	}

	hotSetStatus("apply");
	// insert new code
	for(var moduleId in hotUpdate) {
		var fn = hotUpdate[moduleId];
		if(fn) modules[moduleId] = fn;
		else delete modules[moduleId];
	}

	// call accept handlers
	var error = null;
	for(var moduleId in outdatedDependencies) {
		var module = installedModules[moduleId];
		var moduleOutdatedDependencies = outdatedDependencies[moduleId];
		var callbacks = [];
		for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
			var dependency = moduleOutdatedDependencies[i];
			var cb = module.hot._acceptedDependencies[dependency];
			if(callbacks.indexOf(cb) >= 0) continue;
			callbacks.push(cb);
		}
		for(var i = 0; i < callbacks.length; i++) {
			var cb = callbacks[i];
			try {
				cb(outdatedDependencies);
			} catch(err) {
				if(!error)
					error = err;
			}
		}
	}
	if(error) {
		hotSetStatus("fail");
		return callback(error);
	}

	// Load self accepted
	for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
		var moduleId = outdatedSelfAcceptedModules[i];
		hotCurrentParent = moduleId;
		require(moduleId);
	}

	hotCurrentHash = hotUpdateNewHash;

	hotSetStatus("idle");
	callback(null, outdatedModules);
}

// Load entry module and return exports
return hotCreateRequire(0)(0);